var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nx-bform-group',_vm._b({attrs:{"label":_vm.requiredLabel(_vm.name)}},'nx-bform-group',_vm.$attrs,false),[_c('nx-bform-radio-group',{attrs:{"name":_vm.name,"rules":{ required: _vm.required },"options":[
      { text: _vm.$t('lang-en'), value: 'en' },
      { text: _vm.$t('lang-tc'), value: 'zh-hk' },
      { text: _vm.$t('lang-sc'), value: 'zh-cn' }
    ],"value":_vm.$attrs.value},on:{"input":_vm.$listeners.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }